// 众惠制单经理菜单


let menuProductionManager = [
    
    // {
    //     path:'/',
    //     component: "HomeView",
    //     redirect: '/home/IndexView',
    //     name: '首页',
    //     parent:true,
    //     children:[
    //         {
    //             pageAddress:"IndexView",
    //             path:"/home/IndexView",
    //             component:"IndexView",
    //             name:"实时数据",
    //         }
    //     ]

    // },
    // {
    //     path: '/p0',
    //     component: "HomeView",
    //     name: '营销管理',
	// 	disable:true,//无权限
    // },
	// {
    //     path: '/p1',
    //     component: "HomeView",
    //     name: '运营管理',
    //     disable:true,//无权限
    // },
    // {
	// 	path:'/p2',
    //     redirect: '/common/CMcontractData',
    //     component: "HomeView",
    //     name: '合同管理',
    //     parent:true,
    //     children:[
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"合同管理",
    //             children:[
    //                 // {
    //                 //     pageAddress:"cm/CMcontractData",
    //                 //     path:"/common/CMcontractData",
    //                 //     component:"contractData",
    //                 //     name:"合同总纲",
    //                 //     meta:{
    //                 //         keepAlive:true,
    //                 //     }
    //                 // },
    //                 {
    //                     pageAddress:"commonPage/dataReport/contractDataInfo",
    //                     path:"/common/contractDataInfo",
    //                     component:"contractDataInfo",
    //                     hidden:true,
    //                     name:"合同总纲详情",
    //                 },
    //                 // {
    //                 //     pageAddress:"cm/CMProjectModifyList",
    //                 //     path:"/cm/project/CMProjectModifyList",
    //                 //     component:"CMProjectModifyList",
    //                 //     name:"变更合同"
    //                 // },
    //                 {
    //                     pageAddress:"CommonContractModifyDetail",
    //                     path:"/common/contractModify/CommonContractModifyDetail",
    //                     hidden:true,
    //                     name:"变更合同详情"
    //                 },
    //                 {
    //                     pageAddress:"commonPage/dataReport/contractDataInfo",
    //                     path:"/common/contractDataInfo",
    //                     component:"contractDataInfo",
    //                     hidden:true,
    //                     name:"合同详情",
    //                 },
                    
    //             ]
    //         }
    //     ]

    // },
    // {
    //     path: '/p3',
    //     component: "HomeView",
    //     name: '工程管理',
    //     disable:true,//无权限
    // },
    {
		path:'/p4',
        redirect: '/common/materialList',
        component: "HomeView",
        name: '材料管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"代付材料",
                children:[
                    // {
                    //     pageAddress:"commonPage/financeManage/materialList",
                    //     path:"/common/materialList",
                    //     name:"代付申请"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/materialDetail",
                        path:"/common/materialDetail",
                        hidden:true,
                        name:"代付材料申请详情"
                    },
                    // {
                    //     pageAddress:"commonPage/financeManage/purchaseList",
                    //     path:"/common/purchaseList",
                    //     name:"材料购销合同"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/purchaseDetail",
                        path:"/common/purchaseDetail",
                        hidden:true,
                        name:"材料购销合同详情"
                    },
                    {
                        pageAddress:"commonPage/financeManage/purchaseApply",
                        path:"/common/purchaseApply",
                        hidden:true,
                        name:"新增材料购销合同"
                    },	
                    {
                        pageAddress:"commonPage/financeManage/addMargin",
                        path:"/common/addMargin",
                        hidden:true,
                        name:"新增代付投标保证金申请"
                    },
                    {
                        pageAddress:"commonPage/financeManage/deposit",
                        path:"/common/deposit",
                        hidden:true,
                        name:"新增代付物业押金"
                    },
                    {
                        pageAddress:"commonPage/financeManage/editDeposit",
                        path:"/common/editDeposit",
                        hidden:true,
                        name:"编辑代付物业押金"
                    },
                    {
                        pageAddress:"commonPage/financeManage/depositDetail",
                        path:"/common/depositDetail",
                        hidden:true,
                        name:"代付物业押金详情"
                    },
                    {
                        pageAddress:"commonPage/financeManage/editMargin",
                        path:"/common/editMargin",
                        hidden:true,
                        name:"编辑代付投标保证金申请"
                    },
                    {
                        pageAddress:"commonPage/financeManage/marginDetail",
                        path:"/common/marginDetail",
                        hidden:true,
                        name:"代付投标保证金申请详情"
                    },		
                ]
            }
        ]

    },
    {
		path:'/p5',
        redirect: '/common/applyPaymentList',
        component: "HomeView",
        name: '财务管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"资金管理",
                children:[
                    // {
                    //     pageAddress:"commonPage/financeManage/applyPaymentList",
                    //     path:"/common/applyPaymentList",
                    //     meta: {
                    //         keepAlive: true // 需要被缓存
                    //     },
                    //     name:"用款申请"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/applyPaymentDetail",
                        path:"/common/applyPaymentDetail",
                        hidden:true,
                        name:"用款申请详情"
                    },
                ]
            }
        ]

    },
    
    // {
    //     path: '/p6',
    //     component: "HomeView",
    //     name: '项目总监管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p7',
    //     component: "HomeView",
    //     name: '客户管理',
    //     disable:true,//无权限
    // },
	{
		path:'/p8',
        redirect: '/pm/personaldata/changePassWord',
        component: "HomeView",
        name: '系统管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"个人设置",
                children:[
                    // {
                    //     pageAddress:"pm/PMChangePasswordView",
                    //     path:"/pm/personaldata/changePassWord",
                    //     component:"PMChangePasswordView",
                    //     name:"修改密码"
                    // }
                ]
            }
        ]

    },
    {
        pageAddress:"commonPage/financeManage/NewXiangmushitu",
        path:"/common/New",
        hidden:true,
        name:"项目视图新建页面导出数据"
    },
    {
        pageAddress:"commonPage/financeManage/materialPrint",
        path:"/common/materialPrint",
        hidden:true,
        name:"打印付款申请单"
    },
    {
        pageAddress:"commonPage/financeManage/depositPrint",
        path:"/common/depositPrint",
        hidden:true,
        name:"打印物业押金"
    },
    {
        pageAddress:"commonPage/financeManage/marginPrint",
        path:"/common/marginPrint",
        hidden:true,
        name:"打印代付投标保证金"
    },
];

export default menuProductionManager;


// WEBPACK FOOTER //
// ./src/menu/menuProductionManager.js